import * as React from 'react';
import { useSelector } from 'react-redux';

import { CianGroup } from '../../components/CianGroup';
import { trackDownloadAppClick } from './tracking';
import { selectEventCategory } from '../../selectors/eventCategory';
import { EAppService } from '../../types/appService';

export const CianGroupContainer: React.FC = () => {
  const eventCategory = useSelector(selectEventCategory);

  const handleDownloadAppClick = (event: React.MouseEvent<HTMLAnchorElement>, appService: EAppService) => {
    trackDownloadAppClick({ category: eventCategory, appService });
  };

  return <CianGroup onDownloadAppClick={handleDownloadAppClick} />;
};
